import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getNextPath } from '../utils/path';
import Button from '../components/Button';
import './Validation.styles.styl';

const mapStateToProps = state => ({
  paths: state.path.paths,
  completed: state.task.completed
});

export default function(WrappedComponent) {
  const Pager = ({
    dispatch,
    history,
    location,
    match,
    onClick,
    paths,
    completed,
    ...passThroughProps
  }) => {
    const isButtonDisabled = !completed.includes(match.path);
    const nextPath = getNextPath(paths, match.path);
    const isFrontPage = match.path === '/';

    const scrollToTop = () => {
      const root = document.getElementById('root');
      root.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    };

    return (
      <Fragment>
        <WrappedComponent {...passThroughProps} />
        <div className={isFrontPage ? '' : 'validation-submit-button-wrapper'}>
          <Button
            to={nextPath}
            disabled={isButtonDisabled}
            onClick={scrollToTop}
          >
            {isFrontPage ? 'Begin' : 'Continue'}
          </Button>
        </div>
      </Fragment>
    );
  };

  Pager.propTypes = {
    paths: PropTypes.arrayOf(PropTypes.string).isRequired,
    completed: PropTypes.arrayOf(PropTypes.string).isRequired
  };

  return flow(connect(mapStateToProps), withRouter)(Pager);
}



// WEBPACK FOOTER //
// ../core/src/hocs/Pager.js